<template>
  <div class="container-page big">
    <div class="filter__block mb-4">
      <ButtonComponent mod="gradient-bg" @click="onProjectMapClick">Карта проектов</ButtonComponent>
    </div>

    <SectionStatistics
      class="distribution-of-projects"
      title="Распределение проектов по отраслям"
      type="distribution-of-projects"
      :optionCheckboxCountries="countries"
      :optionCheckboxStatus="statuses"
      :filterMpkData="byIndustry.filter"
      @changeData="beforeChangeFilter($event, 0, 'byIndustry')"
      @clickMore="onClickedBar0"
    >
      <Loader v-if="loading.byIndustry"></Loader>
      <div v-else-if="byIndustry.projects?.length > 0" class="monitoring-content__chart">
        <EChartsHorizontalBar v-bind="getHorizontalBarChartBind('byIndustry')" @clickedBar="onClickedBar0" />
      </div>
      <div v-else>Нет данных...</div>
    </SectionStatistics>

    <SectionStatistics
      class="distribution-of-projects"
      title="Распределение проектов по целям"
      type="distribution-of-projects"
      :optionCheckboxCountries="countries"
      :optionCheckboxStatus="statuses"
      :filterMpkData="byPurpose.filter"
      @changeData="beforeChangeFilter($event, 1, 'byPurpose')"
      @clickMore="onClickedBar1"
    >
      <Loader v-if="loading.byPurpose"></Loader>
      <div v-else-if="byPurpose.projects?.length > 0" class="monitoring-content__chart">
        <div class="chart-inner overflow-auto">
          <EChartsHorizontalBar v-bind="getHorizontalBarChartBind('byPurpose')" @clickedBar="onClickedBar1" />
        </div>
      </div>
      <div v-else>Нет данных...</div>
    </SectionStatistics>

    <SectionStatistics
      class="distribution-of-projects"
      title="Распределение проектов по странам"
      type="distribution-of-projects"
      :optionCheckboxCountries="countries"
      :optionCheckboxStatus="statuses"
      :filterMpkData="byCountry.filter"
      @changeData="beforeChangeFilter($event, 2, 'byCountry')"
      @clickMore="onClickedBar2"
    >
      <!--
        ререндерится графики при получении ответов по апишкам для каждого из графиков
        чтобы этого избежать пришлось добавить такое условие
        + закоментировать внутри каждого из объектов byCountry и тд
        внутр. св-во projects: [],
        ...
      -->
      <Loader v-if="loading.byCountry"></Loader>
      <div v-else-if="byCountry.projects?.length > 0" class="monitoring-content__chart">
        <div class="chart-inner overflow-auto">
          <EChartsHorizontalBar v-bind="getHorizontalBarChartBind('byCountry')" @clickedBar="onClickedBar2" />
        </div>
      </div>
      <div v-else>Нет данных...</div>
    </SectionStatistics>

    <SectionStatistics
      class="distribution-of-projects"
      title="Распределение проектов по МПК"
      type="distribution-of-projects"
      :optionCheckboxCountries="countries"
      :optionCheckboxStatus="statuses"
      :filterMpkData="byMpk.filter"
      @changeData="beforeChangeFilter($event, 3, 'byMpk')"
      @clickMore="onClickedBar3"
    >
      <Loader v-if="loading.byMpk"></Loader>
      <div v-else-if="byMpk.projects?.length > 0" class="monitoring-content__chart">
        <div class="chart-inner overflow-auto">
          <EChartsHorizontalBar v-bind="getHorizontalBarChartBind('byMpk', 'label')" @clickedBar="onClickedBar3" />
        </div>
      </div>
      <div v-else>Данных нет</div>
    </SectionStatistics>

    <SectionStatistics
      title="Динамика изменения портфеля проектов МПК"
      type="portfolio-change-dynamics"
      :optionCheckboxCountries="countries"
      :optionCheckboxStatus="statuses"
      :filterMpkData="filterPCD"
      @changeData="debounceDynamicsChangesProjectPortfolio"
      @clickMore="onClickMorePCD"
    >
      <Loader v-if="loading.byPCD"></Loader>
      <EChartsLine
        v-else
        :xData="dataChangesProjectPortfolio.labelsArray"
        :series="portfolioChangeChartSeries"
        :height="dataChangesProjectPortfolio.height"
        :titleConfig="portfolioChangeChartTitleConfig"
      />
    </SectionStatistics>

    <SectionStatistics
      title="Динамика количества, статусов, включения и исключения проектов МПК"
      type="dynamics-quantity-status-inclusion-exclusion"
      :optionCountries="optionProjectMPKCountries"
      :optionProjectsMPKPortfolio="optionProjectsMPKPortfolioDQSIE"
      :optionEvents="optionProjectMPKEvents"
      :optionProjectMPK="optionProjectMPK"
      :filterMpkData="filterDQSIE"
      @changeData="debounceComplexanAlyticDiagram"
      @clickMore="onClickMoreDynamics"
      idPeriodFrom="period-from-exclusion"
      idPeriodTo="period-to-exclusion"
    >
      <Loader v-if="loading.byDQSIE"></Loader>
      <template v-else>
        <EChartsLine
          :xData="dataDynamicsProjects.labelsArray"
          :yData="dynamicsProjectsChartYData"
          :height="dataDynamicsProjects.height"
          :titleConfig="dynamicsProjectsChartTitleConfig"
          :lineColor="dynamicsProjectsLineColor"
        />
        <TableProject
          :tableInfo="tableInfoProjects"
          @onPageChange="onPageChangeTableProjects"
          @onPageMore="onPageMoreTableProjects"
        />
      </template>
    </SectionStatistics>

    <SectionStatistics
      title="Количество созданных рабочих мест"
      type="number-jobs-created"
      :optionCountries="optionCountries"
      :filterMpkData="filterNJC"
      @changeData="debounceJobsCreated"
      @clickMore="onClickMoreNJC"
      idPeriodFrom="period-from-jobs"
      idPeriodTo="period-to-jobs"
    >
      <EChartsVerticalBar
        :labels="jobsCreated.labels"
        :dataset="jobsCreatedChartDataset"
        :isLoading="loading.byNJC"
        :titleConfig="getJobsCreatedChartTitleConfig"
      />
    </SectionStatistics>

    <SectionStatistics
      title="Доля «зеленых» проектов в портфеле МПК"
      type="share-green-projects"
      :optionCountries="optionCountries"
      :optionProjectsMPKPortfolio="optionProjectsMPKPortfolioSGP"
      :filterMpkData="filterSGP"
      @changeData="onLoadProjectsMPKPortfolio"
      @clickMore="onClickMoreSGP"
    >
      <Loader v-if="loading.bySGP"></Loader>
      <ChartPieProject v-else v-bind="donut" />
    </SectionStatistics>
  </div>
</template>

<script>
  // Additional
  import { debounce } from 'lodash';

  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';
  import text from '@/common/mixins/text';
  import API_COUNTRY from '@/common/utils';
  import Utils from '@/common/utils';

  import EChartsHorizontalBar from '@/components/ChartComponents/apacheEcharts/EChartsHorizontalBar.vue';
  import EChartsLine from '@/components/ChartComponents/apacheEcharts/EChartsLine.vue';
  import EChartsVerticalBar from '@/components/ChartComponents/apacheEcharts/EChartsVerticalBar.vue';
  import { EChartsTitleModes } from '@/components/ChartComponents/apacheEcharts/types';
  import Loader from '@/components/Loader.vue';

  import API_COMMISSION from '@/modules/mpk/api/commission';
  import API_NSI from '@/modules/nsi/api/nsi';

  import API from '../api/index';
  import ChartPieProject from '../components/ChartPieProject.vue';
  import SectionStatistics from '../components/SectionStatistics.vue';
  import TableProject from '../components/TableProject.vue';
  import { usePageFilters } from '../composables/usePageFilters';
  import constants from '../constants';

  import parseParamId from '@/utils/parseParamId';

  export default {
    name: 'ProjectsStatistics',
    setup() {
      const { consumeFilters, navigateWithFilters, updateQueryParams } = usePageFilters(constants.PAGE_KEY.STATISTICS);
      return { consumeFilters, navigateWithFilters, updateQueryParams };
    },
    components: {
      ButtonComponent,
      Loader,
      EChartsHorizontalBar,
      EChartsLine,
      EChartsVerticalBar,
      ChartPieProject,
      SectionStatistics,
      TableProject,
    },
    mixins: [security, text],
    data() {
      return {
        loading: {
          byIndustry: false,
          byPurpose: false,
          byCountry: false,
          byMpk: false,
          byPCD: false,
          byDQSIE: false,
          byNJC: false,
          bySGP: false,
        },
        request: {
          pageNumber: 1,
          pageSize: 0,
        },
        requestMpk: {
          pageNumber: 1,
          pageSize: 0,
          shortFormat: true,
          HasParent: false,
        },
        countries: [],
        purposes: [],
        industries: [],
        mpkProjects: [],
        statuses: [],
        projects: [],
        countryMap: {},
        dynamicCountryNameMap: {},
        byIndustry: {
          filter: {
            countryIds: [],
            statusIds: [],
          },
        },
        byPurpose: {
          filter: {
            countryIds: [],
            statusIds: [],
          },
        },
        byCountry: {
          filter: {
            industryIds: [],
            statusIds: [],
            countryIds: [],
          },
        },
        byMpk: {
          filter: {
            countryIds: [],
            statusIds: [],
          },
          projectsBase: [],
          projects: [],
        },
        // динамика изменения портфеля проектов мпк
        dataChangesProjectPortfolio: {
          countArray: [],
          labelsArray: [],
          title: 'Количество проектов',
          height: 580,
        },

        // динамика количества, статусов, включения и исключения мпк
        dataDynamicsProjects: {
          countArray: [],
          labelsArray: [],
          height: 580,
        },
        defaultComplexanAlyticDiagram: {
          CountryId: '',
          MpkEventMeetingId: '',
          DynamicMode: constants.DEFAULT_DYNAMIC,
          CustomPeriodFrom: '',
          CustomPeriodTo: '',
        },
        paramsGraphComplexanAlyticDiagram: {},
        projectsCurrentPeriod: {
          pageNumber: 1,
          pageSize: 10,
        },
        tableInfoProjects: {
          pageNumber: 1,
          pageSize: 10,
          items: [],
          itemsTotal: 0,
          pagesTotal: 1,
        },

        // кол-во созданых раб. мест
        jobsCreated: {
          labels: [],
          datasets: [],
        },

        // доля зел. проектов в протфеле мпк
        donut: {
          labelsArray: constants.DONUT_PROJECTS_MPK_PORTFOLIO_NAME,
          countArray: [],
          color: constants.DONUT_PROJECTS_MPK_PORTFOLIO_COLOR,
          info: constants.DONUT_PROJECTS_MPK_PORTFOLIO_INFO,
        },

        optionCountries: [],
        optionProjectMPKCountries: [],
        optionProjectMPKEvents: [],
        optionProjectsMPKPortfolioDQSIE: [],
        optionProjectsMPKPortfolioSGP: [],
        optionProjectMPK: [],
        filterPCD: { countryIds: [], statusIds: [] },
        filterDQSIE: { CountryId: '' },
        filterNJC: { countryId: '' },
        filterSGP: { countryId: '' },
        choiceCountryId: '',
        lastFetchedCountryIdForMeetingsDQSIE: null,
        lastFetchedCountryIdForMeetingsSGP: null,
        lastParamsSGPKey: null,
      };
    },
    computed: {
      currentFilter() {
        let filters = {
          byIndustry: this.byIndustry.filter,
          byPurpose: this.byPurpose.filter,
          byCountry: this.byCountry.filter,
          byMpk: this.byMpk.filter,
        };
        return filters;
      },

      getCountryName() {
        const index = this.countries.findIndex((i) => +i.id === +this.choiceCountryId);
        if (index !== -1) {
          return this.countries[index].text;
        }
        return '';
      },

      jobsCreatedChartDataset() {
        return this.jobsCreated.datasets.map((item) => ({
          ...item,
          data: item.data.map((i) => i.x),
          color: item.backgroundColor,
        }));
      },

      getJobsCreatedChartTitleConfig() {
        return {
          text: 'Количество рабочих мест',
          mode: EChartsTitleModes.BACKGROUND,
        };
      },

      portfolioChangeChartSeries() {
        return this.dataChangesProjectPortfolio.countArray.map(({ name, data, color }) => ({
          name,
          data,
          color,
        }));
      },

      portfolioChangeChartTitleConfig() {
        return {
          text: this.dataChangesProjectPortfolio.title,
          mode: EChartsTitleModes.BACKGROUND,
        };
      },

      dynamicsProjectsChartYData() {
        return this.dataDynamicsProjects.countArray[0]?.data ?? [];
      },

      dynamicsProjectsChartTitleConfig() {
        return {
          text: this.getCountryName,
          mode: EChartsTitleModes.BACKGROUND,
        };
      },

      dynamicsProjectsLineColor() {
        return constants.COLORS[1];
      },
    },
    created() {
      const filters = this.consumeFilters() ?? {};
      const { countryIds = [] } = filters;

      this.updateQueryParams(filters);

      if (countryIds.length) {
        [
          this.byIndustry.filter,
          this.byPurpose.filter,
          this.byMpk.filter,
          this.byCountry.filter,
          this.filterPCD,
        ].forEach((f) => (f.countryIds = countryIds));
        this.defaultComplexanAlyticDiagram.CountryId = this.filterDQSIE.CountryId = countryIds[0];
        this.filterNJC.countryId = this.filterSGP.countryId = countryIds[0];
      }

      this.checkPermission(Constants.Permissions.MpkProjectsAccess).then((res) => {
        if (!res.data) {
          this.notAccess('У Вас нет доступа к просмотру статистики проектов.');
        } else {
          this.loadData();

          API.getMpkEventMeetingList()
            .then((response) => {
              if (response.data.length) {
                const mapped = response.data.map((i) => ({
                  value: i.id,
                  label: i.text,
                }));

                this.optionProjectsMPKPortfolioSGP = mapped;
              }
            })
            .catch((err) => {
              console.error('error getMpkEventMeetingList', err);
            });

          API.getDynamicModelist()
            .then((response) => {
              if (response.data.length) {
                this.optionProjectMPK = response.data.map((i) => ({
                  value: i.id,
                  label: i.text,
                }));
              }
            })
            .catch((err) => {
              console.error('error getDynamicModelist', err);
            });

          this.onLoadDataDynamicsChangesProjectPortfolio(
            this.filterPCD.countryIds.length ? { CountryIds: this.filterPCD.countryIds, StatusIds: [] } : undefined,
          );

          if (this.defaultComplexanAlyticDiagram.CountryId) {
            this.onLoadComplexanAlyticDiagram();
          }

          this.onLoadJobsCreated(this.filterNJC.countryId ? { countryId: this.filterNJC.countryId } : undefined);

          this.onLoadProjectsMPKPortfolio(
            this.filterSGP.countryId ? { countryId: this.filterSGP.countryId } : undefined,
          );
        }
      });
    },
    methods: {
      mapMeetingOptions(list) {
        const src = Array.isArray(list) ? list : [];
        return src.map((i) => ({ value: i.id, label: i.text }));
      },
      sortAndMapCountryOptions(countryList) {
        const list = countryList ?? [];
        const collator = new Intl.Collator('ru', { sensitivity: 'base' });

        return list
          .map((country) => ({
            value: country.id,
            label: country.text,
            disabled: false,
          }))
          .sort((leftOption, rightOption) => collator.compare(String(leftOption.label), String(rightOption.label)));
      },
      syncSelectedCountryWithAllowed(allowedIdsSet) {
        const previouslySelectedCountryId = parseParamId(
          this.filterDQSIE.CountryId ?? this.defaultComplexanAlyticDiagram.CountryId ?? this.choiceCountryId,
        );
        const nextSelectedCountryId = allowedIdsSet.has(previouslySelectedCountryId) ? previouslySelectedCountryId : '';

        this.filterDQSIE.CountryId = nextSelectedCountryId;
        this.defaultComplexanAlyticDiagram.CountryId = nextSelectedCountryId;
        this.choiceCountryId = nextSelectedCountryId;
      },
      fetchMeetingsDQSIE(countryId) {
        if (countryId === this.lastFetchedCountryIdForMeetingsDQSIE) return Promise.resolve();

        return API.getMpkProjectDynamicCommissionList({ countryId })
          .then((resp) => {
            this.optionProjectsMPKPortfolioDQSIE = this.mapMeetingOptions(resp.data);
            this.lastFetchedCountryIdForMeetingsDQSIE = countryId;
          })
          .catch((err) => {
            console.error('error getMpkEventMeetingList', err);
          });
      },
      fetchMeetingsSGP(countryId) {
        if (countryId === this.lastFetchedCountryIdForMeetingsSGP) return Promise.resolve();

        return API.getMpkEventMeetingList({ countryId })
          .then((resp) => {
            this.optionProjectsMPKPortfolioSGP = this.mapMeetingOptions(resp.data);
            this.lastFetchedCountryIdForMeetingsSGP = countryId;
          })
          .catch((err) => {
            console.error('error getMpkEventMeetingList', err);
          });
      },
      async fetchMpkProjectDynamicEventList(countryId, mpkComissionId) {
        if (!countryId) {
          return;
        }
        try {
          const response = await API.getMpkProjectDynamicEventList({ countryId, mpkComissionId });
          this.optionProjectMPKEvents = this.mapMeetingOptions(response.data);
        } catch (error) {
          console.error('Error:', error);
        }
      },
      makeMpkLabel(name, countryName) {
        const c = String(countryName || '').trim();
        return c ? `${c}. ${name}` : name;
      },
      groupByKey(items, keyField) {
        const grouped = new Map();
        items.forEach((it) => {
          const base = it[keyField];
          if (!base) return;
          const k = String(base);
          if (!grouped.has(k)) grouped.set(k, []);
          grouped.get(k).push(it);
        });
        return grouped;
      },
      buildMpkBase(grouped) {
        const baseArr = Array.from(grouped.entries()).map(([id, arr]) => {
          return {
            id: +id,
            data: arr.length,
          };
        });
        return baseArr.sort((a, b) => b.data - a.data);
      },
      getItemsFromResponse(response) {
        return response && response.data && response.data.items ? response.data.items : [];
      },
      buildGenericProjects(grouped, dict) {
        const resArr = Array.from(grouped.entries()).map(([id, arr]) => {
          const dictItemname = dict.find((d) => d.id == id)?.text || '';
          return { name: dictItemname, data: arr.length };
        });
        return resArr.sort((a, b) => b.data - a.data);
      },
      processMpk(grouped, obj) {
        const sortedBase = this.buildMpkBase(grouped);
        this.byMpk.projectsBase = sortedBase;
        obj.projects = sortedBase.map(({ id, data }) => {
          const arr = grouped.get(String(id)) || [];
          const mpkComissionCountryName = String(arr[0]?.mpkComissionCountryName ?? '');
          const name = String(arr[0]?.mpkComissionName ?? '');

          return {
            data,
            mpkComissionId: id,
            mpkComissionCountryName,
            label: this.makeMpkLabel(name, mpkComissionCountryName),
          };
        });
      },
      processGeneric(grouped, dict, obj) {
        const sorted = this.buildGenericProjects(grouped, dict);
        obj.projects = sorted.map(({ name, data }) => ({ name, data }));
      },
      closeLoading(keyField) {
        if (keyField == 'countryId') {
          this.loading.byCountry = false;
        } else if (keyField == 'industryId') {
          this.loading.byIndustry = false;
        } else if (keyField == 'purposeId') {
          this.loading.byPurpose = false;
        } else if (keyField == 'mpkComissionId') {
          this.loading.byMpk = false;
        }
      },
      loadPage(byIndustry, byPurpose, byCountry, byMpk) {
        if (byIndustry) {
          this.loadProjects(this.byIndustry.filter, 'industryId', this.byIndustry, this.industries);
        }
        if (byPurpose) {
          this.loadProjects(this.byPurpose.filter, 'purposeId', this.byPurpose, this.purposes);
        }
        if (byCountry) {
          this.loadProjects(this.byCountry.filter, 'countryId', this.byCountry, this.countries);
        }
        if (byMpk) {
          this.loadProjects(this.byMpk.filter, 'mpkComissionId', this.byMpk, this.mpkProjects);
        }
      },
      loadProjects(filter, keyField, obj, dict) {
        if (keyField == 'countryId') {
          this.loading.byCountry = true;
        } else if (keyField == 'industryId') {
          this.loading.byIndustry = true;
        } else if (keyField == 'purposeId') {
          this.loading.byPurpose = true;
        } else if (keyField == 'mpkComissionId') {
          this.loading.byMpk = true;
        }
        var params = Object.assign({}, filter, this.request);

        API.search(params)
          .then((response) => {
            const items = this.getItemsFromResponse(response);
            const grouped = this.groupByKey(items, keyField);
            if (keyField === 'mpkComissionId') {
              this.processMpk(grouped, obj);
            } else {
              this.processGeneric(grouped, dict, obj);
            }
            this.closeLoading(keyField);
          })
          .catch(() => {
            this.closeLoading(keyField);
          });
      },
      loadData() {
        //страны
        API.getProjectMPKCountries().then((response) => {
          const responseCountries = response.data;
          this.optionProjectMPKCountries = this.sortAndMapCountryOptions(responseCountries);

          const allowedCountryIdsSet = new Set(responseCountries.map((country) => Number(country.id)));
          this.syncSelectedCountryWithAllowed(allowedCountryIdsSet);
        });

        API_COUNTRY.searchNsi('countryList').then((response) => {
          if (response.data && response.data.length) {
            response.data.forEach((i) => {
              this.countries.push(i);
              this.countryMap[i.id] = i.text;
            });
            response.data.forEach((i) =>
              this.optionCountries.push({
                value: i.id,
                label: i.text,
                disabled: false,
              }),
            );
          }
          this.loadProjects(this.byCountry.filter, 'countryId', this.byCountry, this.countries);
          API.getDynamicsChangesProjectPortfolio(this.formattingParamsChangesProjectPortfolio(undefined)).then(
            (resp) => {
              const data = resp.data;

              if (data) {
                const names = Object.keys(data);
                const nameIndex = new Map(this.countries.map((c) => [String(c.text).toLowerCase(), c.id]));
                const mapped = names.reduce((acc, name) => {
                  const id = nameIndex.get(String(name).toLowerCase());
                  if (id) {
                    this.dynamicCountryNameMap[id] = name;
                    acc.push({ value: id, label: name, disabled: false });
                  }
                  return acc;
                }, []);
                if (mapped.length) this.optionCountries = mapped;
              }
            },
          );
        });
        Utils.loadSelectOptions('mpkProjectStatusList', this.statuses);
        //отрасли
        API_NSI.search('NsiIndustry', this.request).then((response) => {
          if (response.data) {
            this.industries = response.data.items.map((o) => {
              return { text: o.name, id: o.id };
            });
          }
          this.loadProjects(this.byIndustry.filter, 'industryId', this.byIndustry, this.industries);
        });
        //цели
        API_NSI.search('MpkProjectPurpose', this.request).then((response) => {
          if (response.data) {
            this.purposes = response.data.items.map((o) => {
              return { text: o.name, id: o.id };
            });
          }
          this.loadProjects(this.byPurpose.filter, 'purposeId', this.byPurpose, this.purposes);
        });
        // мпк
        API_COMMISSION.search(this.requestMpk).then((response) => {
          if (response.data) {
            this.mpkProjects = response.data.items.map((o) => {
              return { text: o.name, id: o.id };
            });
          }
          this.loadProjects(this.byMpk.filter, 'mpkComissionId', this.byMpk, this.mpkProjects);
        });
      },
      changeFilter(mode) {
        this.loadPage(mode === 0, mode === 1, mode === 2, mode === 3);
      },
      getHorizontalBarChartBind(sectionKey, labelKey = 'name') {
        const projects = this[sectionKey]?.projects ?? [];

        return {
          key: String(this.loading[sectionKey]),
          showLegend: false,
          valueFractionDigits: 0,
          barMaxWidth: 20,
          labels: projects.map((item) => item[labelKey]),
          dataset: [{ data: projects.map((item) => item.data), color: '#0093BA' }],
        };
      },
      onClickedBar0() {
        this.navigateWithFilters(constants.PAGE_KEY.LIST, {
          countryIds: this.byIndustry.filter.countryIds,
          statusIds: this.byIndustry.filter.statusIds,
        });
        this.$router.push({ name: 'Projects' });
      },
      onClickedBar1() {
        this.navigateWithFilters(constants.PAGE_KEY.LIST, {
          countryIds: this.byPurpose.filter.countryIds,
          statusIds: this.byPurpose.filter.statusIds,
        });
        this.$router.push({ name: 'Projects' });
      },
      onClickedBar2(index) {
        let countryIds = this.byCountry.filter.countryIds;
        if (typeof index === 'number' && index >= 0) {
          const country = this.byCountry.projects[index].name;
          const found = this.countries.find((i) => i.text == country);
          if (found) countryIds = [found.id];
        }
        this.navigateWithFilters(constants.PAGE_KEY.LIST, {
          countryIds,
          statusIds: [...(this.byCountry.filter.statusIds ?? [])],
        });
        this.$router.push({ name: 'Projects' });
      },
      onClickedBar3() {
        this.navigateWithFilters(constants.PAGE_KEY.LIST, {
          countryIds: this.byMpk.filter.countryIds,
          statusIds: this.byMpk.filter.statusIds,
        });
        this.$router.push({ name: 'Projects' });
      },
      onProjectMapClick() {
        this.$router.push({ name: 'ProjectsMap' });
      },

      formattingParamsChangesProjectPortfolio(params) {
        if (params) {
          const { CountryIds, StatusIds } = params;
          let format = '';
          if (CountryIds.length) {
            CountryIds.forEach((i) => {
              if (!format) {
                format = `CountryIds=${i}`;
              } else {
                format += `&CountryIds=${i}`;
              }
            });
          }
          if (StatusIds.length) {
            StatusIds.forEach((i) => {
              if (!format) {
                format = `StatusIds=${i}`;
              } else {
                format += `&StatusIds=${i}`;
              }
            });
          }
          return format;
        }
      },

      onLoadDataDynamicsChangesProjectPortfolio(params) {
        this.loading.byPCD = true;
        API.getDynamicsChangesProjectPortfolio(this.formattingParamsChangesProjectPortfolio(params))
          .then((response) => {
            const data = response.data;
            if (data !== null) {
              const countArray = [];
              let labelsArray = [];
              const color = constants.COLORS;
              let colorCounter = 0;

              for (const [key, value] of Object.entries(data)) {
                const dataList = [];
                for (const [, valueJ] of Object.entries(value)) {
                  dataList.push(valueJ);
                }
                countArray.push({
                  name: key,
                  data: dataList,
                  color: color[colorCounter],
                });
                ++colorCounter;
              }

              if (countArray.length > 0) {
                labelsArray = Object.keys(Object.entries(data)[0]?.[1]);
              }

              this.dataChangesProjectPortfolio.countArray = countArray;
              this.dataChangesProjectPortfolio.labelsArray = labelsArray;
            } else {
              this.dataChangesProjectPortfolio.countArray = [];
              this.dataChangesProjectPortfolio.labelsArray = [];
            }
          })
          .catch((err) => {
            console.error('error onLoadDataDynamicsChangesProjectPortfolio', err);
          })
          .finally(() => {
            this.loading.byPCD = false;
          });
      },

      debounceDynamicsChangesProjectPortfolio: debounce(function (data) {
        if (data) {
          this.filterPCD.countryIds = data.CountryIds ?? [];
          this.filterPCD.statusIds = data.StatusIds ?? [];
        }
        this.onLoadDataDynamicsChangesProjectPortfolio(data);
      }, 500),

      getLabelGraph(key) {
        if (key === 'currentPeriod') {
          return constants.CURRENT_PERIOD;
        }
        if (key === 'previousPeriod') {
          return constants.PREVIOUS_PERIOD;
        }

        return key;
      },

      onLoadProjectsForStatistics(params) {
        if (!params.CountryId) {
          return;
        }
        API.getSearchProjectsForStatistics({
          ...params,
          ...this.projectsCurrentPeriod,
        })
          .then((response) => {
            if (response.data !== null) {
              this.tableInfoProjects = response.data;
            } else {
              this.tableInfoProjects = {
                pageNumber: 1,
                pageSize: 10,
                items: [],
                itemsTotal: 0,
                pagesTotal: 1,
              };
            }
          })
          .catch((err) => {
            console.error('error onLoadProjectsForStatistics', err);
          });
      },

      onPageChangeTableProjects(count) {
        this.projectsCurrentPeriod.pageNumber = count;
        this.onLoadProjectsForStatistics(this.paramsGraphComplexanAlyticDiagram);
      },

      onPageMoreTableProjects(count) {
        this.projectsCurrentPeriod.pageNumber = count;
        API.getSearchProjectsForStatistics({
          ...this.paramsGraphComplexanAlyticDiagram,
          ...this.projectsCurrentPeriod,
        })
          .then((response) => {
            this.tableInfoProjects.items = this.tableInfoProjects.items.concat(response.data.items);
          })
          .catch((err) => {
            console.error('error onLoadProjectsForStatistics', err);
          });
      },

      async onLoadComplexanAlyticDiagram(params = this.defaultComplexanAlyticDiagram) {
        if (!params.CountryId) {
          return;
        }

        try {
          this.loading.byDQSIE = true;
          const response = await API.getComplexanAlyticDiagram(params);

          this.paramsGraphComplexanAlyticDiagram = params;
          this.choiceCountryId = params.CountryId;
          await this.fetchMeetingsDQSIE(params.CountryId);

          await this.fetchMpkProjectDynamicEventList(params.CountryId, params.mpkComissionId);

          const data = response.data;

          if (data !== null) {
            this.dataDynamicsProjects.countArray = [
              {
                name: '',
                data: Object.values(data),
              },
            ];
            this.dataDynamicsProjects.labelsArray = Object.keys(data);
          } else {
            this.dataDynamicsProjects.countArray = [];
            this.dataDynamicsProjects.labelsArray = [];
          }
        } catch (error) {
          console.error('Error onLoadComplexanAlyticDiagram:', error);
        } finally {
          this.loading.byDQSIE = false;
        }

        this.onLoadProjectsForStatistics(params);
      },

      debounceComplexanAlyticDiagram: debounce(function (data) {
        this.onLoadComplexanAlyticDiagram(data);
      }, 1000),

      onLoadJobsCreated(params) {
        this.loading.byNJC = true;
        API.getNumberJobsCreated(params)
          .then((response) => {
            const data = response.data;
            const labels = Object.keys(data);
            const datasetTemporary = {
              label: constants.NUMBER_OF_TEMPORARY_JOBS,
              data: [],
              backgroundColor: '#01A39D',
            };
            const datasetsPermanent = {
              label: constants.NUMBER_OF_PERMANENT_JOBS,
              data: [],
              backgroundColor: '#0078C8',
            };

            if (Object.keys(data).length) {
              Object.values(data).forEach((i) => {
                datasetTemporary.data.push({ x: +i.transient });
                datasetsPermanent.data.push({ x: +i.constant });
              });
            }

            this.jobsCreated.labels = labels;
            this.jobsCreated.datasets = [datasetTemporary, datasetsPermanent];
          })
          .catch((err) => {
            console.error('error onLoadJobsCreated', err);
          })
          .finally(() => {
            this.loading.byNJC = false;
          });
      },

      debounceJobsCreated: debounce(function (data) {
        if (data?.countryId !== undefined) this.filterNJC.countryId = data.countryId;
        this.onLoadJobsCreated(data);
      }, 1000),

      onLoadProjectsMPKPortfolio(params) {
        if (params?.countryId !== undefined) this.filterSGP.countryId = params.countryId;
        const countryId = params?.countryId || null;
        const requestKey = `${countryId || ''}:${params?.mpkEventMeetingId || ''}`;
        if (requestKey === this.lastParamsSGPKey && this.optionProjectsMPKPortfolioSGP.length) {
          this.loading.bySGP = false;
          return;
        }
        this.lastParamsSGPKey = requestKey;
        this.loading.bySGP = true;
        this.fetchMeetingsSGP(countryId);
        API.getProjectsMPKPortfolio(params)
          .then((response) => {
            const { doneProjects = 0, allProjects = 0 } = response.data;
            if (!doneProjects && !allProjects) {
              this.donut.countArray = [];
            } else {
              this.donut.countArray = [doneProjects, allProjects - doneProjects];
            }
            this.donut.info.forEach((i) => {
              if (i.id === 'implemented-projects') {
                i.count = doneProjects;
              }
              if (i.id === 'total-projects') {
                (i.count = allProjects), (i.color = '#231F20');
              }
            });
          })
          .catch((err) => {
            console.error('error onLoadProjectsMPKPortfolio', err);
          })
          .finally(() => {
            this.loading.bySGP = false;
          });
      },

      onClickMoreDynamics() {
        const countryId = this.choiceCountryId || this.filterDQSIE.CountryId;
        this.navigateWithFilters(constants.PAGE_KEY.LIST, {
          countryIds: countryId ? [Number(countryId)] : [],
        });
        this.$router.push({ name: 'Projects' });
      },
      onClickMorePCD() {
        this.navigateWithFilters(constants.PAGE_KEY.LIST, {
          countryIds: this.filterPCD.countryIds ?? [],
          statusIds: this.filterPCD.statusIds ?? [],
        });
        this.$router.push({ name: 'Projects' });
      },
      onClickMoreNJC() {
        this.navigateWithFilters(constants.PAGE_KEY.LIST, {
          countryIds: this.filterNJC.countryId ? [Number(this.filterNJC.countryId)] : [],
        });
        this.$router.push({ name: 'Projects' });
      },
      onClickMoreSGP() {
        this.navigateWithFilters(constants.PAGE_KEY.LIST, {
          countryIds: this.filterSGP.countryId ? [Number(this.filterSGP.countryId)] : [],
        });
        this.$router.push({ name: 'Projects' });
      },

      beforeChangeFilter(data, index, type) {
        let { CountryIds, StatusIds } = data;
        this[type].filter.countryIds = CountryIds;
        this[type].filter.statusIds = StatusIds;
        this.changeFilter(index);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .chart-inner {
    max-height: 1200px;
  }
  .monitoring {
    &-container {
      margin-bottom: 70px;

      .title {
        font-weight: 500;
        margin-bottom: 24px;
      }
    }
    &-content {
      &__header {
        .filter {
          display: flex;
          margin-bottom: 32px;
          width: 100%;
          &__block {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 25%;
            font-family: 'Fira Sans', sans-serif;
            background-color: transparent;
            padding: 0;
            &:not(:last-of-type) {
              margin-right: 18px;
            }
            .input-container {
              width: 100%;
            }
          }
        }
      }
    }
  }
  // Media
  @media (max-width: 1024px) {
    .monitoring-content__header .filter {
      flex-wrap: wrap;
    }
  }
  @media (max-width: 768px) {
    .monitoring-content__header .filter__block:not(:last-of-type) {
      margin-bottom: 8px;
    }
  }
</style>
